export default function() {
	return {
		loadedSearch: { id:-1, labelKey: 'resetSearch', },
		mapState: {
			cluster: null,
			selectedOrderNode: {},
			orderCluster: null,
			tooltipVisible: false,
			clusterTooltipVisible: false,
			popup: null,
			terminals: [],
		},
		// General map settings
		showDeliveriesInMap: false,
		tripsOnTopInMap: true,
		tripDetailsVisible: false,
		mapOrderIds: null,
		gridSelecting: false,
		mapSelecting: false,
		selectedMapOrderIds: [],
		selectedGridOrderIds: [],
		filteredGridOrderIds: null,
	};
}
